/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useState, useEffect } from "react";
import { CarouselItem } from "~/ProductDetails/Carousel/CarouselItem";
import CarouselMember from "~/ProductDetails/Carousel/CarouselMember";
import { bindRecAiClickEvent, getCarouselObserver } from "~/userAnalytics";
import { sendGtmEvent } from "~/analytics/definitions";
type Props = {
  carouselItems: readonly CarouselItem[];
  id?: string;
  showAddToCart?: boolean;
  gtmCarouselName?: string;
  addCarouselItemToCart?: (itemNumber: string, quantity: string, accessories?: string) => void;
  isCartCarousel?: boolean;
};
const Carousel = ({
  carouselItems,
  id,
  showAddToCart,
  gtmCarouselName,
  addCarouselItemToCart,
  isCartCarousel = false
}: Props) => {
  const heightWithoutQtyDropdown = 288;
  const heightWithQtyDropdown = 336;
  const [containsQuantityDropdown, setContainsQuantityDropdown] = useState(false);
  const [containerHeight, setContainerHeight] = useState(heightWithoutQtyDropdown);
  useEffect(() => {
    if (containsQuantityDropdown) {
      setContainerHeight(heightWithQtyDropdown);
    } else {
      setContainerHeight(heightWithoutQtyDropdown);
    }
  }, [containsQuantityDropdown]);
  useEffect(() => {
    async function importCarouselFunctionality() {
      if (document.querySelector("[data-component=carousel]")) {
        const {
          default: initCategoryCarousels
        } = await import("~/common/initCategoryCarousels");
        initCategoryCarousels();
      }
    }
    importCarouselFunctionality();
  }, []);
  useEffect(() => {
    if (carouselItems.length && id) {
      const carouselAnchor = document.querySelector(`#${id}`);
      if (carouselAnchor instanceof HTMLElement) {
        const carouselObserver = getCarouselObserver(carouselAnchor, "recAiEvent");
        carouselObserver.observe(carouselAnchor);
      }
      sendGtmEvent({
        event: "recAiEvent",
        eventLabel: `${id}`,
        eventAction: "AI Impression"
      });
      bindRecAiClickEvent(`#${id}`);
    }
  }, [id, carouselItems.length]);
  return <div className="basic-carousel carousel-box init" data-component="carousel" data-testid="homepage-carousel-base" gtm-carousel-name={gtmCarouselName} id={id} data-sentry-component="Carousel" data-sentry-source-file="Carousel.tsx">
      <div className="ag-carousel-nav">
        <button type="button" className="ag-car-prev" data-control="prev" aria-label="previous set of slides" />
      </div>
      <div className="ag-carousel-frame box relative">
        <ul className="ag-carousel ag-full" style={showAddToCart ? {
        height: `${containerHeight}px`
      } : {}} data-testid={`carousel-${id}`}>
          {carouselItems.map(carouselItem => <CarouselMember item={carouselItem} showAddToCart={showAddToCart ?? false} addCarouselItemToCart={addCarouselItemToCart} addToCartFormId={`relatedproduct_reccommended_${carouselItem.itemNumber}`} containsQuantityDropdown={containsQuantityDropdown} setContainsQuantityDropdown={setContainsQuantityDropdown} key={carouselItem.itemNumber} isCartCarousel={isCartCarousel} />)}
        </ul>
      </div>
      <div className="ag-carousel-nav">
        <button type="button" className="ag-car-next" data-control="next" aria-label="next set of slides" />
      </div>
    </div>;
};
export default Carousel;